<template>
  <div class="outlined-icon clickable" @click="$emit('click', $event)">
    <slot />
  </div>
</template>

<script>
export default {
  props: ['value'],
}
</script>

<style lang="scss" scoped>
.outlined-icon {
  border: 1px solid lightblue;
  border-radius: 100%;
  min-width: 26px;
  height: 26px;
}
</style>